import React from 'react';
import {generateColumnClass} from "../../Utility";

const TextInput = ({name, value, error, label, onChange, onBlur, columns, placeholder, inline, disabled = false}) => {
    const columnClass = generateColumnClass(columns);
    const className = `${inline ? 'd-flex flex-wrap ' : ''}col-12${columnClass}`;
    return (
        <div className={className}>
            {label &&
                <label className={`form-label opacity-75${inline ? ' mb-0 py-2 col-12 col-md-4' : ''}`}
                       htmlFor={name}>
                    {label}
                </label>
            }
            <input type="text"
                   className={`form-control${inline ? ' col' : ''}`}
                   name={name}
                   value={value}
                   placeholder={placeholder}
                   onChange={onChange}
                   onBlur={onBlur}
                   id={name}
                   disabled={disabled}/>
            {error && <div
                className={`form-text text-start text-danger w-100${inline && label ? ' offset-md-4' : ''}`}>{error}</div>}
        </div>
    )
};

export default TextInput;

